import React from 'react';
import { useStateContext } from '../../context/StateContext';
import { Link } from 'react-router-dom';

const HeroSlideItem = ({ item }) => {
  const getPosterURL = (posterpath) => {
    return `https://image.tmdb.org/t/p/original/${posterpath}`;
  };
  const getPosterCard = (posterpath) => {
    return `https://image.tmdb.org/t/p/w500/${posterpath}`;
  };

  const imgPath = item.backdrop_path;
  const posterPath = item.poster_path;

  const { setModal, setTrailerId } = useStateContext();

  return (
    <div
      className="w-full pt-28 pb-4 px-0 relative bg-center bg-cover bg-no-repeat before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-black/60 after:absolute after:bottom-0 after:left-0 after:w-full after:h-24 after:bg-gradient-to-t after:from-black after:to-black/5 md:py-44 "
      style={{
        backgroundImage: `url(${getPosterURL(imgPath)})`,
      }}
    >
      <div className="flex items-center justify-center relative flex-row w-full container mx-auto px-5 md:px-6">
        <div className="flex flex-col h-96 w-full md:w-3/5 py-0 relative text-white gap-9">
          <h1 className="font-bold text-4xl sm:text-6xl md:text-7xl">
            {item.title}
          </h1>
          <h2 className="font-bold text-sm">
            {item.overview.length > 250
              ? `${item.overview.substring(0, 250)}....`
              : item.overview}
          </h2>
          <div className="flex flex-row gap-5 lg:text-2xl font-semibold">
            <Link
              to={`/movie/${item.id}`}
              className="bg-red-500 px-4 py-1 md:px-7 md:py-2 rounded-3xl shadow-[0_0_7px_8px_rgba(255,0,0,0.2)] "
            >
              Watch Now
            </Link>
            <button
              className="border-2 px-4 py-1 md:px-7 md:py-2 rounded-3xl"
              onClick={() => {
                setModal(true);
                setTrailerId(item.id);
              }}
            >
              Watch trailer
            </button>
          </div>
        </div>
        <div className="flex-1 flex items-center justify-start relative max-md:hidden">
          <img
            src={getPosterCard(posterPath)}
            className="w-[400px] rounded-3xl shadow-xl max-w-full md:h-[500px] lg:h-[600px]"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSlideItem;
